import { Box, GridItem, HStack, Text } from '@cdl/heartbeat-react';
import { TaskMetricSection } from './TaskMetricSection';
import { dateConverter } from '../../utils/task.utils';
import { AnnotationTask } from '../../../ecg/types/annotation-tasks.type';

type Props = {
  annotationTask: AnnotationTask;
};

export const WorkingDays: React.FC<Props> = ({ annotationTask }) => {
  return (
    <GridItem colSpan={1}>
      <TaskMetricSection>
        <Text textStyle='category-title'>Working days</Text>
        <HStack mt='xl' gap='xxl' alignItems='top'>
          <Box>
            <Text textStyle='small-label'>Remaining</Text>
            <Text fontSize='52px' fontWeight='bold' mt='s'>
              {annotationTask.remainingDays || 0}
            </Text>
          </Box>
          <Box color='neutral.200'>
            <Text textStyle='small-label'>Already Done</Text>
            <Text fontSize='52px' fontWeight='bold' mt='s'>
              {annotationTask.workingDays || 0}
            </Text>
          </Box>
        </HStack>
        <Box mt='l' fontSize='xs'>
          <HStack>
            <Text fontWeight='bold'>Created in: </Text>
            <Text>{dateConverter(annotationTask.createdAt).slice(0, 10)}</Text>
          </HStack>
          {annotationTask.remainingDays != null && annotationTask.eta != null && (
            <HStack>
              <Text fontWeight='bold'>Estimated due date: </Text>
              <Text>{annotationTask.eta}</Text>
            </HStack>
          )}
          {annotationTask.effectiveDate != null && (
            <HStack>
              <Text fontWeight='bold'>Effective date: </Text>
              <Text>
                {dateConverter(annotationTask.effectiveDate).slice(0, 10)}
              </Text>
            </HStack>
          )}
        </Box>
      </TaskMetricSection>
    </GridItem>
  );
};
